<!-- Content -->
<div *ngIf="type=='fundraiser'" class="page-content">
  <!-- Placeholder Content -->
  <div class="placeholder-content">
    <div class="placeholder-content_item"></div>
    <div class="placeholder-content_item"></div>
    <div class="placeholder-content_item"></div>
    <div class="placeholder-content_item"></div>
    <div class="placeholder-content_item"></div>
    <div class="placeholder-content_item"></div>
    <div class="placeholder-content_item"></div>
  </div>
</div>

<div *ngIf="type=='donor'" class="page-content pt-0">
  <!-- Placeholder Content -->
  <div class="donor-loader" *ngFor="let item of loaderCount; let i=index">
    <span class="donor-loader_item"></span>
    <span class="donor-loader_item"></span>
  </div>
</div>

<div *ngIf="type=='text'" class="page-content pt-0">
  <!-- Placeholder Content -->
  <div class="text-loader" *ngFor="let item of loaderCount; let i=index">
    <span class="text-loader_item"></span>
  </div>
</div>

<div *ngIf="type=='upi'" class="page-content pt-0">
  <!-- Placeholder Content -->
  <div class="upi-loader" *ngFor="let item of loaderCount; let i=index">
    <span class="upi-loader_item"></span>
    <span class="upi-loader_item"></span>
    <span class="upi-loader_item"></span>
    <span class="upi-loader_item"></span>
    <span class="upi-loader_item"></span>
    <span class="upi-loader_item"></span>
    <span class="upi-loader_item"></span>
    <span class="upi-loader_item"></span>
  </div>
</div>

<div *ngIf="type=='story'" class="page-content">
  <!-- Placeholder Content -->
  <div *ngIf="isMobile">
    <div class="story-loader-mobile">
      <div class="circular-loader_item"></div>
      <div class="line-loader_item"></div>
    </div>
    <div class="story-loader-mobile">
        <div class="line-loader_item width100"></div>
    </div>
    <div class="story-loader-mobile">
        <div class="line-loader_item width100"></div>
    </div>
    <div class="story-loader-mobile">
        <div class="line-loader_item width100 height100"></div>
    </div>
    <div class="story-loader-mobile">
        <div class="line-loader_item width100"></div>
        <div class="line-loader_item width100"></div>
    </div>
    <div class="story-loader-mobile">
        <div class="line-loader_item width100 height100"></div>
    </div>
  </div>

  <div *ngIf="!isMobile">
    <div class="story-loader">
      <span class="story-loader_item"></span>
      <span class="story-loader_item"></span>
      <span class="story-loader_item"></span>
      <span class="story-loader_item"></span>
      <span class="story-loader_item"></span>
      <span class="story-loader_item"></span>
      <span class="story-loader_item"></span>
    </div>
  </div>
</div>